<bn-loading-overlay></bn-loading-overlay>
<div class="container">
  <div class="row">
    <div class="col">
      <h4>Solicitação de Renúncia</h4>
    </div>
    <div class="col-auto">
      <button class="btn btn-danger" type="button" routerLink="../pesquisa">Cancelar</button>
      <button class="btn btn-primary" type="button" (click)="abrirModalConfirmarSolicitacaoRenuncia()"
        [disabled]="renunciaFormGroup.invalid || garantiaRenunciaFormGroup.invalid || !podeSalvar">Salvar</button>
    </div>
  </div>

  <ul ngbNav #nav="ngbNav" class="col nav-tabs">
    <li [ngbNavItem]="'garantia-renunciar'" id="garantia-renunciar" title="Garantia a Renunciar">
        <button ngbNavLink>Garantia a Renunciar</button>
        <ng-template ngbNavContent>
            <form [formGroup]="garantiaRenunciaFormGroup">
                <div class="row">
                    <div class="bn-form-group col-md-12">
                        <label class="form-label">Valor comprometido pelo FUNDO para eventual honra de operações da Tranche 1 deste Agente
                            Financeiro
                            R$</label>
                    </div>
                    <div class="bn-form-group col-md-3">
                        <input type="text" class="form-control" bnMask="MOEDA"
                            formControlName="valorComprometidoPeloFundo" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <hr>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <span style="font-weight: bolder; color: gray;">Com base na informação acima e o atual LDC (Stop
                            Loss
                            disponível), o VALOR MÁXIMO a ser renunciado é:</span>
                    </div>
                </div>
                <div class="row" style="margin-top: 2em;">
                    <div class="bn-form-group col-md-12">
                        <label class="form-label" style="color: blue">Valor máximo a ser renunciado para descomprometer o montante total
                            indicado
                            acima R$</label>
                    </div>
                    <div class="bn-form-group col-md-3">
                        <input type="text" class="form-control" bnMask="MOEDA"
                            ngbTooltip="É o limite disponível de cobertura da Tranche 1, subtraído do valor estimado das honras solicitadas no mês atual da renúncia."
                            formControlName="valorMaximoASerRenunciadoParaDescomprometer" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6" *ngIf="valorComprometidoPeloFundoMaiorQueZero()">
                        <div class="row">
                            <div class="col-md-6">
                                <label class="form-label" style="color: green">Valor a RENUNCIAR R$</label>
                                <input (input)="removeQuadro()" type="text" class="form-control" bnMask="MOEDA"
                                    formControlName="valorRenunciado" placeholder="digite o valor a ser renunciado"
                                    ngbTooltip="É o valor da cobertura máxima de inadimplência que será renunciado por meio desta solicitação de renúncia." />
                                <small class="text-danger"
                                    *ngIf="valorRenunciadoTemErro('valorRenunciadoMaiorQuePermitido')">Valor a renúnciar
                                    não pode ser maior que Valor máximo a ser renunciado (R$)</small>
                            </div>
                            <div class="col-md-6">
                                <br>
                                <button class="btn btn-primary" type="button" *ngIf="valorARenunciarMaiorQueZero()"
                                    [disabled]="valorARenunciarMaiorMaximoPermitido()"
                                    (click)="calcularValores()">Calcular Descomprometido</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6" *ngIf="calculadoValores">
                        <br>
                        <div class="row"
                            style="border-style: solid; border-style: solid; border-color: orange; padding: 2em;">
                            <span style="font-weight: bold;">Valor descomprometido para novas contratações R$</span>
                            <input type="text" class="form-control" bnMask="MOEDA"
                                formControlName="valorDescomprometidoNovasContratacoes"
                                ngbTooltip="É o valor reservado atualmente pelo fundo para futuras honras deste agente financeiro na primeira tranche (2020) e que, a depender do montante renunciado, poderá ser liberado para novas contratações." />

                            <span>Acréscimo exclusivo ao limite do renunciante R$</span>
                            <input type="text" class="form-control" bnMask="MOEDA"
                                formControlName="acrescimoExclusivoAoLimiteRenunciante" />

                            <span>Acréscimo ao limite de todos os agentes conforme regulamento R$</span>
                            <input type="text" class="form-control" bnMask="MOEDA"
                                formControlName="acrescimoAoLimiteTodosAgentes" />
                        </div>
                        <div class="row"
                            style="border-style: solid; border-style: solid; border-color: orange; padding: 1em; margin-top: 2em;">
                            <span>LDC (Stop loss) após Renúncia R$</span>
                            <input type="text" class="form-control" bnMask="MOEDA"
                                formControlName="ldcStopLossAposRenuncia" />
                        </div>
                    </div>
                </div>
            </form>
        </ng-template>
    </li>
    <li [ngbNavItem]="'distribuicao-valor'" id="distribuicao-valor"
        title="Distribuição valor descomprometido para novas contratações">
        <button ngbNavLink>Distribuição valor descomprometido para novas contratações</button>
        <ng-template ngbNavContent>
            <form [formGroup]="renunciaFormGroup">
                <div class="row">
                    <div class="bn-form-group col-md-4">
                        <label class="form-label"><b>Valor Descomprometido (R$)</b></label>
                        <input type="text" class="form-control" formControlName="valorDescomprometidoNovasContratacoes"
                            bnMask="MOEDA" />
                    </div>
                </div>
                <div class="row">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th class="text-center">Previsão da distribuição</th>
                                    <th class="text-center col-md-3">Valor para distribuição (R$)*</th>
                                    <th class="text-center col-md-3" style="color: orangered;">Acréscimo exclusivo ao
                                        limite do renunciante (R$)*</th>
                                    <th class="text-center col-md-3" style="color: orangered;">Acréscimo ao limite de
                                        todos os agentes conforme regulamento (R$)*</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
                                    <td>
                                        <div class="bn-form-group" style="text-align: center;"><label class="form-label"><b>Bimestre {{ '0' +
                                                    item
                                                    }}</b></label></div>
                                    </td>
                                    <td>
                                        <div class="bn-form-group"><input type="text" class="form-control"
                                                [formControlName]="'valorParaDistribuicao0' + item" bnMask="MOEDA" />
                                        </div>
                                    </td>
                                    <td>
                                        <div class="bn-form-group">
                                            <input type="text" class="form-control" disabled
                                                [value]="calculaValoresAcrescimos('valorParaDistribuicao0' + item)"
                                                bnMask="MOEDA" />
                                        </div>
                                    </td>
                                    <td>
                                        <div class="bn-form-group">
                                            <input type="text" class="form-control" disabled
                                                [value]="calculaValoresAcrescimos('valorParaDistribuicao0' + item)"
                                                bnMask="MOEDA" />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        Totais: R$ {{ totalDistribuicao() | bnMask:'MOEDA' }}
                                    </td>
                                    <td>
                                        R$ {{ totaisAcrescimos50() | bnMask:'MOEDA' }}
                                    </td>
                                    <td>
                                        R$ {{ totaisAcrescimos50() | bnMask:'MOEDA' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </form>
        </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>


<ng-template #mensagemTermoRenuncia>
  <div class="bn-form-group row">
    <div class="col">
      <label>Termos e condições:</label>
    </div>
  </div>
  <div class="row">
    <div class="bn-form-group col-12">
      <textarea class="form-control" rows="10" disabled [(ngModel)]="textoTermoRemuneracaoCoberturaMaxima"></textarea>
    </div>
  </div>
  <div class="bn-form-group row">
    <div class="col">
      <div class="form-check">
        <input type="checkbox" class="form-check-input" id="checkCiencia" [(ngModel)]="checkCiencia">
        <label class="form-check-label" for="checkCiencia">Declaro que estou ciente dos termos e condições
          aplicáveis</label>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #botoesTermosRenuncia>
  <button class="btn btn-default" (click)="desistirDoSolicitacaoRenuncia()">Cancelar</button>
  <button class="btn btn-primary" [disabled]="!checkCiencia" (click)="salvar()">Confirmar</button>
</ng-template>
